import { useContext, useEffect, useState } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

export default function Start() {
  const {
    setSessionId,
    setOrgName,
    setAdminEmail,
    setInviteToken,
    setCurrentStep
  } = useContext(OnboardingContext);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const stripeStatus = params.get("stripe");

    async function start() {
      try {
        // Load onboarding session
        const res = await fetch(`/api/admin-onboarding/start?token=${token}`);
        const data = await res.json();
        const checkoutSessionId = params.get("cs_id");

        if (data.error) {
          setError(data.error);
          setLoading(false);
          return;
        }

        // Store onboarding session data
        setSessionId(data.onboarding_session_id);
        setOrgName(data.org_name);
        setAdminEmail(data.admin_email);
        setInviteToken(data.invite_token);

        // Handle Stripe success callback
        if (stripeStatus === "success") {
          try {
            await fetch("/api/admin-onboarding/stripe-success", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                session_id: data.onboarding_session_id,
                checkout_session_id: checkoutSessionId
              })
            });

            // ⭐ Reload updated onboarding session
            const updatedRes = await fetch(`/api/admin-onboarding/start?token=${token}`);
            const updatedData = await updatedRes.json();

            data.status = updatedData.status; // ⭐ overwrite stale status

          } catch (err) {
            console.error("Stripe success handler error:", err);
          }
        }

        // ⭐ Resume onboarding step based on backend status
        switch (data.status) {
          case "details_completed":
            setCurrentStep("billing");
            break;
          case "billing_completed":
            setCurrentStep("limits");
            break;
          case "limits_completed":
            setCurrentStep("legal");
            break;
          case "legal_completed":
            setCurrentStep("finish");
            break;
          default:
            setCurrentStep("start");
        }

      } catch (err) {
        setError("Unable to start onboarding.");
      }

      setLoading(false);
    }

    start();
  }, []);

  if (loading) return <div>Loading…</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      <h2>Welcome to CloudGenomics</h2>
      <p>
        You have been invited to register your organization on the CloudGenomics
        platform. This process will take just a few minutes.
      </p>

      <button onClick={() => setCurrentStep("details")}>
        Begin Registration
      </button>
    </div>
  );
}